export function toggleActionMenu(actions, active, marked, filter = '') {
  if (filter === 'Home') return actions
  let menu = actions.concat(active)
  if(Array.isArray(filter)){
    return (marked) ? menu.filter(menu => !filter.includes(menu.name)) : actions
  } else {
    return (marked) ? menu.filter((menu) => menu.name !== filter) : actions
  }
}